import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DealDocumentUtility {
  get docTypes() {
    return {
      '4506t': {
        display: '4506T',
        value: '4506t',
        alias: '4506t',
        attributeId: 594
      },
      'achAuthorization': {
        display: 'ACH Authorization Form',
        value: 'achAuthorization',
        alias: 'ach_authorization',
        attributeId: 1949
      },
      'amendmentToArticles': {
        display: 'Amendment to Articles',
        value: 'amendmentToArticles',
        alias: 'amendment_to_articles',
        attributeId: 1936
      },
      'amendmentToBylaws': {
        display: 'Amendment to Bylaws',
        value: 'amendmentToBylaws',
        alias: 'amendment_to_bylaws',
        attributeId: 1937
      },
      'amendmentToOperatingAgreement': {
        display: 'Amendment to Operating Agreement',
        value: 'amendmentToOperatingAgreement',
        alias: 'amendment_to_operating_agreement',
        attributeId: 1938
      },
      'applicationBlank': {
        display: 'Application - Blank',
        value: 'applicationBlank',
        alias: 'application_blank',
        attributeId: 570,
      },
      'applicationSigned': {
        display: 'Application - Signed',
        value: 'applicationSigned',
        alias: 'application_signed',
        attributeId: 574
      },
      'applicationUnsigned': {
        display: 'Application - Unsigned',
        value: 'applicationUnsigned',
        alias: 'application_unsigned',
        attributeId: 572
      },
      'articlesOfIncorporation': {
        display: 'Articles of Incorporation',
        value: 'articlesOfIncorporation',
        alias: 'articles_of_incorporation',
        attributeId: 795
      },
      'balanceSheet': {
        display: 'Balance Sheet',
        value: 'balanceSheet',
        alias: 'balance_sheet',
        attributeId: 856
      },
      'bankStatement': {
        display: 'Bank Statement',
        value: 'bankStatement',
        alias: 'bank_statement',
        attributeId: 576,
      },
      'bankVerification': {
        display: 'Bank Verification',
        value: 'bankVerification',
        alias: 'bankVerification',
        attributeId: 808
      },
      'beneficialOwnershipCertification' : {
        display: 'Certification of Beneficial Ownership (CBO)',
        value: 'beneficialOwnershipCertification',
        alias: 'beneficial_ownership_certification',
        attributeId: 1926
      },
      'businessHistory': {
        display: 'Business History',
        value: 'businessHistory',
        alias: 'business_history',
        attributeId: 1677
      },
      'businessLicenses': {
        display: 'Business License',
        value: 'businessLicenses',
        alias: 'business_licenses',
        attributeId: 582
      },
      'businessTaxReturns': {
        display: 'Business Tax Return',
        value: 'businessTaxReturns',
        alias: 'business_tax_returns',
        attributeId: 680
      },
      'businessVerification': {
        display: 'Business Verification',
        value: 'businessVerification',
        alias: 'business_verification',
        attributeId: 767
      },
      'certificateOfCorporateSecretary': {
        display: 'Certificate of Corporate Secretary',
        value: 'certificateOfCorporateSecretary',
        alias: 'certificate_of_corporate_secretary',
        attributeId: 1671
      },
      'creditCardAttestation': {
        display: 'Credit Card Attestation',
        value: 'creditCardAttestation',
        alias: 'credit_card_attestation',
        attributeId: 1941
      },
      'confessionOfJudgment': {
        display: 'Confession of Judgment (COJ)',
        value: 'confessionOfJudgment',
        alias: 'confessionOfJudgment',
        attributeId: 809
      },
      'contractUnsigned': {
        display: 'Contract - Unsigned',
        value: 'contractUnsigned',
        alias: 'contract_unsigned',
        attributeId: 604
      },
      'contractSigned': {
        display: 'Contract - Signed',
        value: 'contractSigned',
        alias: 'contract_signed',
        attributeId: 606
      },
      'creditReport': {
        display: 'Credit Report',
        value: 'creditReport',
        alias: 'credit_report',
        attributeId: 610
      },
      'currentCitizenVerification': {
        display: 'Current Citizen Verification',
        value: 'currentCitizenVerification',
        alias: 'currentCitizenVerification',
        attributeId: 810
      },
      'customerList': {
        display: 'Customer List',
        value: 'customerList',
        alias: 'customer_list',
        attributeId: 793
      },
      'customerInvoice': {
        display: 'Customer Invoice',
        value: 'invoice',
        alias: 'customer_invoice',
        attributeId: 794
      },
      'dbaFiling': {
        display: 'DBA Filing',
        value: 'dbaFiling',
        alias: 'dba_filing',
        attributeId: 1672
      },
      'debtSchedule': {
        display: 'Debt Schedule',
        value: 'debtSchedule',
        alias: 'debt_schedule',
        attributeId: 642
      },
      'driverLicense': {
        display: 'Driver\'s License',
        value: 'driverLicense',
        alias: 'drivers_license',
        attributeId: 586
      },
      'equipmentInfo': {
        display: 'Equipment Info',
        value: 'equipmentInfo',
        alias: 'equipment_info',
        attributeId: 768
      },
      'evidenceOfResidence': {
        display: 'Evidence of residence',
        value: 'evidenceOfResidence',
        alias: 'evidence_of_residence',
        attributeId: 1942
      },
      'financials': {
        display: 'Financials',
        value: 'financials',
        alias: 'personal_financial_statement',
        attributeId: 646
      },
      'franchiseAddendum': {
        display: 'Franchise Addendum',
        value: 'franchiseAddendum',
        alias: 'franchise_addendum',
        attributeId: 1934
      },
      'franchiseAgreement': {
        display: 'Franchise Agreement',
        value: 'franchiseAgreement',
        alias: 'franchise_agreement',
        attributeId: 1933
      },
      'invoice': {
        display: 'Invoice',
        value: 'invoice',
        alias: 'invoice',
        attributeId: 614
      },
      'IRS943': {
        display: 'IRS Form 943',
        value: 'IRS943',
        alias: 'IRS943',
        attributeId: 1691
      },
      'irsInstallmentPlan': {
        display: 'IRS Installment Plan',
        value: 'irsInstallmentPlan',
        alias: 'irs_installment_plan',
        attributeId: 1928
      },
      'leaseAmendment': {
        display: 'Lease Amendment',
        value: 'leaseAmendment',
        alias: 'lease_amendment',
        attributeId: 1935
      },
      'letterOfExplanation': {
        display: 'Letter of Explanation',
        value: 'letterOfExplanation',
        alias: 'letter_of_explanation',
        attributeId: 1931
      },
      'lienRelease': {
        display: 'Lien Release',
        value: 'lienRelease',
        alias: 'lien_release',
        attributeId: 1932
      },
      'llcOperatingAgreementOrCorpBylaws': {
        display: 'LLC Operating Agreement or Corp Bylaws',
        value: 'llcOperatingAgreementOrCorpBylaws',
        alias: 'llc_operating_agreement_or_corp_bylaws',
        attributeId: 796
      },
      'loanDisclosure': {
        display: 'Loan Disclosure',
        value: 'loanDisclosure',
        alias: 'loanDisclosure',
        attributeId: 0,
      },
      'managementResume': {
        display: 'Management Resume',
        value: 'managementResume',
        alias: 'management_resume',
        attributeId: 1675
      },
      'merchantStatement': {
        display: 'Merchant Processing Statement',
        value: 'merchantStatement',
        alias: 'merchant_statement',
        attributeId: 578
      },
      'mortgageStatements': {
        display: 'Mortgage Statement',
        value: 'mortgageStatements',
        alias: 'mortgage_statements',
        attributeId: 596
      },
      'mtdTransactions': {
        display: 'Month-To-Date Transactions',
        value: 'mtdTransactions',
        alias: 'mtdTransactions',
        attributeId: 859
      },
      'offerSigned': {
        display: 'Offer - Signed',
        value: 'offerSigned',
        alias: 'offer_signed',
        attributeId: 602
      },
      'offerUnsigned': {
        display: 'Offer - Unsigned',
        value: 'offerUnsigned',
        alias: 'offer_unsigned',
        attributeId: 600
      },
      'openInvoiceReport': {
        display: 'Open Invoice Report',
        value: 'openInvoiceReport',
        alias: 'open_invoice_report',
        attributeId: 792
      },
      'other': {
        display: 'Other',
        value: 'other',
        alias: 'other',
        attributeId: 608
      },
      'ownershipVerification': {
        display: 'Ownership Verification',
        value: 'ownershipVerification',
        alias: 'ownershipVerification',
        attributeId: 812
      },
      'paymentHistory': {
        display: 'Payment History',
        value: 'paymentHistory',
        alias: 'payment_history',
        attributeId: 1681
      },
      'payoffLetters': {
        display: 'Payoff Letter',
        value: 'payoffLetters',
        alias: 'payoff_letters',
        attributeId: 598
      },
      'payoffQuote': {
        display: 'Payoff Quote',
        value: 'payoffQuote',
        alias: 'payoff_quote',
        attributeId: 1943
      },
      'personalTaxReturns': {
        display: 'Personal Tax Return',
        value: 'personalTaxReturns',
        alias: 'personal_tax_returns',
        attributeId: 678
      },
      'pLCurrentYear': {
        display: 'P&L Current Year',
        value: 'pLCurrentYear',
        alias: 'pl_current_year',
        attributeId: 626
      },
      'pLPreviousYear': {
        display: 'P&L Previous Year',
        value: 'pLPreviousYear',
        alias: 'pl_previous_year',
        attributeId: 1850
      },
      'ppp944Permission' : {
        display: 'IRS Form 944 Written Permission',
        value: 'ppp944Permission',
        alias: 'ppp944Permission',
        attributeId: 917
      },
      'pppApplicationSigned': {
        display: 'PPP Application Signed',
        value: 'pppApplicationSigned',
        alias: 'pppApplicationSigned',
        attributeId: 873
      },
      'pppApplicationUnsigned': {
        display: 'PPP Application Unsigned',
        value: 'pppApplicationUnsigned',
        alias: 'pppApplicationUnsigned',
        attributeId: 874
      },
      'pppBankStatement' : {
        display: 'Bank Statement - PPP',
        value: 'pppBankStatement',
        alias: 'pppBankStatement',
        attributeId: 887
      },
      'pppCorporateReturn' : {
        display: 'Corporate Tax Return - PPP',
        value: 'pppCorporateReturn',
        alias: 'pppCorporateReturn',
        attributeId: 886
      },
      'pppDocuments' : {
        display: 'PPP Documents',
        value: 'pppDocuments',
        alias: 'pppDocuments',
        attributeId: 879
      },
      'pppIncomeExpense' : {
        display: 'Income and expense report - PPP',
        value: 'pppIncomeExpense',
        alias: 'pppIncomeExpense',
        attributeId: 888
      },
      'pppIRS940' : {
        display: 'IRS Form 940',
        value: 'pppIRS940',
        alias: 'pppIRS940',
        attributeId: 897
      },
      'pppIRS941' : {
        display: 'IRS Form 941',
        value: 'pppIRS941',
        alias: 'pppIRS941',
        attributeId: 884
      },
      'pppIRS944' : {
        display: 'IRS Form 944',
        value: 'pppIRS944',
        alias: 'pppIRS944',
        attributeId: 885
      },
      'pppIRS990' : {
        display: 'IRS Form 990',
        value: 'pppIRS990',
        alias: 'pppIRS990',
        attributeId: 918
      },
      'pppIRS1099' : {
        display: 'IRS Form 1099',
        value: 'pppIRS1099',
        alias: 'pppIRS1099',
        attributeId: 889
      },
      'pppPayrollProcessor' : {
        display: 'Payroll Processor Report',
        value: 'pppPayrollProcessor',
        alias: 'pppPayrollProcessor',
        attributeId: 883
      },
      'pppScheduleC' : {
        display: 'IRS Form 1040 Schedule C',
        value: 'pppScheduleC',
        alias: 'pppScheduleC',
        attributeId: 890
      },
      'pppW2' : {
        display: '2019 Form W2',
        value: 'pppW2',
        alias: 'pppW2',
        attributeId: 916
      },
      'pppW3' : {
        display: '2019 Form W3',
        value: 'pppW3',
        alias: 'pppW3',
        attributeId: 915
      },
      'promissoryNote': {
        display: 'Promissory Note',
        value: 'promissoryNote',
        alias: 'promissory_note',
        attributeId: 1680
      },
      'professionalLiabilityCertificateOfInsurance': {
        display: 'Professional Liability Certificate of Insurance',
        value: 'professionalLiabilityCertificateOfInsurance',
        alias: 'professional_liability_certificate_of_insurance',
        attributeId: 1939
      },
      'professionalLicense': {
        display: 'Professional License',
        value: 'professionalLicense',
        alias: 'professional_license',
        attributeId: 1673
      },
      'proofOfFiling': {
        display: 'Proof of Filing',
        value: 'proofOfFiling',
        alias: 'proof_of_filing',
        attributeId: 1930
      },
      'statementOfInformation': {
        display: 'Statement of Information (CA/NY)',
        value: 'statementOfInformation',
        alias: 'statement_of_information',
        attributeId: 1929
      },
      'stockTransferAgreement': {
        display: 'Stock Transfer Agreement',
        value: 'stockTransferAgreement',
        alias: 'stock_transfer_agreement',
        attributeId: 1940
      },
      'taxConsentForm': {
        display: 'Tax Consent Form',
        value: 'taxConsentForm',
        alias: 'tax_consent_form',
        attributeId: 1678
      },
      'taxTranscripts': {
        display: 'Tax Transcripts',
        value: 'taxTranscripts',
        alias: 'tax_transcripts',
        attributeId: 1679
      },
      'uscisForm': {
        display: 'USCIS Form',
        value: 'uscisForm',
        alias: 'uscis_form',
        attributeId: 1676
      },
      'vendorInfo': {
        display: 'Vendor Info',
        value: 'vendorInfo',
        alias: 'vendor_info',
        attributeId: 618
      },
      'voidedCheck': {
        display: 'Voided Check',
        value: 'voidedCheck',
        alias: 'voided_check',
        attributeId: 584
      }
    };
  }

  get documentAliasToCategory() {
    return {
      'drivers_license'               : 'driverLicense',
      'merchant_processing_statement' : 'merchantStatement',
      'pl_current_year'               : 'pLCurrentYear',
      'pl_previous_year'              : 'pLPreviousYear',
      'personal_financial_statement'  : 'financials',
      '4506t'                         : '4506t',
      'llc_operating_agreement_or_corp_bylaws': 'llcOperatingAgreementOrCorpBylaws',
      'articles_of_incorporation'     : 'articlesOfIncorporation',
      'customer_list'                 : 'customerList',
      'open_invoice_report'           : 'openInvoiceReport',
      'debt_schedule'                 : 'debtSchedule',
      'balance_sheet'                 : 'balanceSheet'
    };
  }

  get signedApplicationRequirement() {
    return {
      category: {
        display: 'Application - Signed',
        value: 'applicationSigned',
        alias: 'application_signed',
        attributeId: 574
      },
      alias: 'application_signed',
      dbName: 'applicationSigned',
      name: 'Signed Application',
      shortName: 'Signed Application',
      type: 'document',
      allowedQualifiers: null,
      appSection: null,
      appSectionOrder: null,
      contractAskable: true,
      created: '',
      createdTimestamp: 0,
      deleted: null,
      dependsExpression: null,
      dependsOn: null,
      filterable: false,
      group: null,
      groupOrder: null,
      helpText: '',
      id: 0,
      mask: null,
      maskOptions: null,
      maxLength: null,
      minLength: null,
      modified: '',
      modifiedTimestamp: 0,
      mustAllowNull: false,
      offerAskable: true,
      options: null,
      order: 0,
      pattern: null,
      patternError: null,
      placeholder: '',
      requiredForContract: false,
      requiredForOffer: false,
      sectionId: 0,
      teamId: null,
      documentQuantity: null,
      lenderId: null,
      requirement: []
    };
  }

  get loanDisclosureRequirement() {
    return {
      category: {
        display: 'Loan Disclosure',
        value: 'loanDisclosure',
        alias: 'loanDisclosure',
        attributeId: 0
      },
      alias: 'loanDisclosure',
      dbName: 'loanDisclosure',
      name: 'Loan Disclosure',
      shortName: 'Loan Disclosure',
      type: 'document',
      allowedQualifiers: null,
      appSection: null,
      appSectionOrder: null,
      contractAskable: true,
      created: '',
      createdTimestamp: 0,
      deleted: null,
      dependsExpression: null,
      dependsOn: null,
      filterable: false,
      group: null,
      groupOrder: null,
      helpText: '',
      id: 0,
      mask: null,
      maskOptions: null,
      maxLength: null,
      minLength: null,
      modified: '',
      modifiedTimestamp: 0,
      mustAllowNull: false,
      offerAskable: true,
      options: null,
      order: 0,
      pattern: null,
      patternError: null,
      placeholder: '',
      requiredForContract: true,
      requiredForOffer: false,
      sectionId: 0,
      teamId: null,
      documentQuantity: null,
      lenderId: null,
      requirement: []
    };
  }
}
